// 语音通话与 媒体平台操作的 文件
import { CHAT, websocketapp } from '@/common/websocket/index'
import { getSession } from '@/api/common'
import { meetRegister } from '@/api/mediaPlane'
import { extendMd } from '@/common/rtc/srs/jquery.md5'
import { HwRtcSignaling } from '@/common/rtc/srs/hwmedia.sig'
import { HwRtcPublisherAsync, HwRtcPlayerAsync } from '@/common/rtc/srs/hwmedia.sdk'
import store from '@/store/index'

var code = ''

/**
 * 声音关闭
 */
const VOLUME_OFF = 0
/**
 * 声音开启
 */
const VOLUME_ON = 1

// 当前的房间号
let roomId = null

// 是否有麦克风设备
let hasMic = false

/**
 * 外部设置 安全帽掉线处理逻辑
 * @param {Function} callback 安全帽掉线处理逻辑
 */
function setHandleHelmetLeave(callback) {
  handleHelmetLeave = callback
}
var busCode = null
var tokenData = null
var reqTime = null
var reqCode = null
var accessCode = null
var content = null
var sign = null

//创建webRtc推流对象
var publisher = null

// 会议号
function getMeet() {
  roomId = 'meet' + randomNumstr(6)
}

// http 请求头参数
function handleHeader() {
  busCode = { busCode: roomId }

  tokenData = 'mspuser1'
  reqTime = Math.floor(new Date().getTime() / 1000) //req-time:
  reqCode = Number(parseInt(new Date().getTime() * Math.random() * 100))
    .toString(16)
    .substr(0, 7)
  // 验签码
  accessCode = 'abcdefg123456789'
  //待(加密)签名字符串
  content = tokenData + reqCode + reqTime + '{"busCode":"' + roomId + '"}' + accessCode
  // 加密sign
  sign = extendMd(content)
}
// 会议码
var meetCode = null
// 创建会议
async function walkieRegist() {
  await getMeet()
  await handleHeader()
  meetRegister(busCode, tokenData, reqCode, reqTime, sign).then(res => {
    if (res.state === 0) {
      meetCode = res.data.meetCode
      loginMVCPWalke(res.data.meetCode)
      // getMeetInfo()
    }
  })
}

//创建信令===============================
var sig = new HwRtcSignaling()
var sigConnFlag = false
//开启打印日志
sig.openDebug()

var beginTime = 0 //执行onbeforeunload的开始时间
var differTime = 0 //时间差
window.onunload = function() {
  differTime = new Date().getTime() - beginTime
  if (differTime <= 5) {
    sig.wsClose()
    closeResetMeetSRS()
    console.log('浏览器关闭') // 这儿可以放浏览器关闭时的执行代码
  } else {
    console.log('浏览器刷新') // 这儿可以放浏览器刷新时的执行代码
  }
}
//监听窗口关闭事件，当窗口关闭时，主动去关闭信令
window.onbeforeunload = function() {
  beginTime = new Date().getTime()
}
var wsUrl = null
var rtcUrl = null
var wsHost = null
/**
 * websocket与视频平台建立连接
 */
async function loginMVCPWalke(room) {
  wsUrl = store.getters.srsWsUrl
  let urlInfo = wsUrl.split('/')
  rtcUrl = urlInfo[2]
  await checkMic()
  if (window.location.host.includes('localhost:808')) {
    // wsHost = 'wss://192.168.0.48/hwmsp/media/meetWS'
    wsHost = 'wss://intranet.iot.huaweisoft.com/hwmsp/media/meetWS'
  } else {
    wsHost = wsUrl + 'meetWS'
  }
  const clientCode = Number(parseInt(new Date().getTime() * Math.random() * 100))
    .toString(16)
    .toString(16)
    .substr(0, 7)
  const tokenMode = 0
  //检查信令对象
  if (sig.sigCheckAlive()) {
    // warning('信令仍然存活，不需要重新连接')
  } else {
    try {
      //信令连接.. 等待回调
      sigConnFlag = await sig.sigConnect(wsHost, room, clientCode, tokenMode)
      console.log('sigConnect...  sigConnFlag=' + sigConnFlag)
      if (sigConnFlag) {
        //获取令牌
        sig.myTokenInfo = await sig.sigQueryToken()
        sig.myToken = sig.myTokenInfo.myToken
      }
    } catch (e) {
      console.log('语音通话信令连接失败' + e)
    }
  }
}
// 离开会议
function closeResetMeetSRS() {
  console.log('离开会议',sig)
  try {
    let audioDom = document.getElementById('walkieDom')
    audioDom.srcObject = null
    store.commit('openWaike', false)
    if (publisher) {
      publisher.close()
    }
    if (sig) {
      // 请求离开会议
      sig.sigReqDisconnect()
      sig.sigClose()
      setTimeout(() => {
        if (getSession('access_token')) {
          walkieRegist()
        }
      }, 2000)
    }
  } catch (e) {
    console.log('离开会议失败')
  }
}
var allUser = []
//使用await发布视频

async function helmetJoinMeetSRS(helmetList) {
  allUser = helmetList
  var paramJson = { outFlv: false, saveVideo: false, onVideo: false, onAudio: true }
  //请求推流
  sig.reqPublishResInfo = await sig.sigReqPublish(paramJson)
  store.commit('openWaike', true)
  console.log('请求推流', sig.reqPublishResInfo)
  if (sig.reqPublishResInfo && sig.reqPublishResInfo.meetCode) {
    await noticeHelmetMeet(helmetList)
    //可以返回会议编号，就表示申请成功了
    //异步启动自身
    startPublishMedia(sig.reqPublishResInfo)
  }
  //获取房间信息.
  sig.roomInfo = await sig.sigQueryRoom()
  console.log('获取房间信息', sig.roomInfo, sig.roomInfo.meetCode)
  if (sig.roomInfo && sig.roomInfo.meetCode) {
    //存在会议编号
    setTimeout(function() {
      //播放其它客户端
      playRoomClient(sig.roomInfo)
    }, 1000)
  }
}
//(覆盖回调方法) 房间内推流信息变化，服务器回调信息
sig.sigServerNotifyClientPublishChange = function(roomInfoJson) {
  console.log('服务器回调信息', roomInfoJson)

  if (roomInfoJson) {
    // 客户离开会议
    if (roomInfoJson.event === 'clientLeave') {
      let clients = []
      for (let item of roomInfoJson.clientList) {
        clients.push(item.clientCode)
      }
    } else {
      sig.roomInfo = roomInfoJson
      console.log(' 房间内推流信息变化', sig.roomInfo)
      //播放其它客户端
      if (publisher) {
        playRoomClient(sig.roomInfo)
      }
    }
  }
}
var publishtrack = null
// 请求推流
function startPublishMedia(reqPublishResData) {
  if (publisher) {
    publisher.close()
  }
  /*
  // var port = 80
  // if (reqPublishResData.serverPortMap && reqPublishResData.serverPortMap.httpsApi) {
  //   port = reqPublishResData.serverPortMap.httpsApi
  // }
  // var rtcSdpUrl = 'https://' + reqPublishResData.serverIp + ':' + reqPublishResData.serverPortMap.httpsApi
  // var videoElm = document.getElementById('walkieDom')
  */
  var rtcSdpUrl = 'https://' + rtcUrl + '/hwmsp/media'
  if (publisher) {
    publisher.close()
  }

  publisher = new HwRtcPublisherAsync()
  // 开启打印
  publisher.openDebug()

  //覆盖sdk里面的通知推流成功的回调function
  publisher.callbackOnAddStream = function(event) {
    //等待回调
    // if (videoElm) videoElm.srcObject = event.stream
  }
  //覆盖sdk里面的推流状态改变的回调function
  publisher.callbackOnPeerConnectionStateChange = function(event) {
    //event是连接事件对象
    queryPublishConnectionState()
  }

  var rtcHostIp = '' //rtc服务器推流拉流使用udp协议。如果有多个ip或者需要代理ip才能传输流，可以通过这个参数传入指定的ip
  var publishVideo = false //传输视频
  var publishAudio = true //传输音频
  //定义浏览器webrtc推流参数
  //详细参数访问： https://developer.mozilla.org/zh-CN/docs/Web/API/MediaDevices/getUserMedia
  // var navigatorMediaInfo = { audio: true }
  var navigatorMediaInfo = {
    audio: { echoCancellation: true, noiseSuppression: true, autoGainControl: true },
    video: false,
  }

  //推流
  publisher
    .publishStream(rtcSdpUrl, rtcHostIp, sig.myToken, navigatorMediaInfo, publishVideo, publishAudio)
    .then(function(session) {
      console.log('推流成功', session)
    })
    .catch(function(reason) {
      publisher.close()
      console.error('推流失败', reason)
    })
}
var queryPublishConnCount = 0
function queryPublishConnectionState() {
  if (!publisher) {
    return
  }
  //查询到连接当前状态
  var peerState = publisher.getPublishConnectionState()
  queryPublishConnCount++
  if (peerState === 'failed' || peerState === 'closed') {
    console.log('推流已断开！！！')
  } else if (peerState === 'disconnected') {
    if (queryPublishConnCount > 5) {
      console.log('推流已断开！！！')
      return
    }
    console.log('推流不稳定！！！')
    //3秒后再递归调用
    setTimeout(function() {
      queryPublishConnectionState()
    }, 3000)
  } else {
    queryPublishConnCount = 0
  }
}

var clientPlayers = {} //存放播放器对象
function playRoomClient(roomInfo) {
  var lastestPlayers = {} //最新的客户端
  roomInfo.clientList.forEach(function(clientInfo) {
    lastestPlayers[clientInfo.token] = clientInfo
  })
  var waitDelPlayers = {} //待删除的客户端
  $.each(clientPlayers, function(tokenKey, obj) {
    //先判断正在播放的客户端已经失效
    if (!lastestPlayers[tokenKey]) {
      //不在的话，删除dev
      obj.player.close()
      // obj.ui.remove()
      waitDelPlayers[tokenKey] = tokenKey
    } else {
      //已经在播放，但可能已经不推流
      if (!lastestPlayers[tokenKey].publishing) {
        obj.player.close()
        // obj.ui.remove()
        waitDelPlayers[tokenKey] = tokenKey
      } else {
        //delete lastestPlayers[tokenKey];
      }
    }
  })

  $.each(waitDelPlayers, function(tokenKey) {
    delete clientPlayers[tokenKey] //删除
  })

  roomInfo.clientList.forEach(function(clientInfo) {
    console.log(
      'sig.roomInfo.clientInfo=' + clientInfo.token,
      sig.myToken,
      clientInfo.publishing,
      !clientPlayers[clientInfo.token]
    )
    //客户端信息不是自己的 && 在推流中 && 不在播放中
    if (clientInfo.token != sig.myToken && clientInfo.publishing && !clientPlayers[clientInfo.token]) {
      setTimeout(function() {
        //播放其它客户端
        playClient(clientInfo)
      }, 500)
    }
  })
}
//播放其它客户端
function playClient(clientInfo) {
  console.log('播放其它客户端', clientInfo)
  var cliToken = clientInfo.token
  if (!cliToken) {
    return
  }
  //创建其它客户端的rtc播放对象
  let rtcPlayerObj = new HwRtcPlayerAsync()
  // 开启打印
  rtcPlayerObj.openDebug()
  //
  let audioElm = document.getElementById('walkieDom')
  audioElm.srcObject = null
  console.log('.cliToken=' + cliToken, audioElm)
  clientPlayers[cliToken] = { video: audioElm, player: rtcPlayerObj }

  //覆盖sdk里面的推流状态改变的回调function
  rtcPlayerObj.callbackOnPeerConnectionStateChange = function(event) {
    //event是连接事件对象
    queryPlayConnectionState(cliToken)
  }

  //覆盖sdk里面的回调通知function
  rtcPlayerObj.callbackOnAddStream = function(event) {
    //event.stream是 浏览器的navigator.mediaDevices.getUserMedia对象
    console.log('浏览器的对象override play callbackOnAddStream()..Start play, event: ', audioElm, event)

    if (audioElm) audioElm.srcObject = event.stream
    // unmuteMic()
  }
  var rtcSdpUrl = 'https://' + rtcUrl + '/hwmsp/media'
  var rtcHostIp = '' //rtc服务器推流拉流使用udp协议。如果有多个ip或者需要代理ip才能传输流，可以通过这个参数传入指定的ip

  var playVideo = false //传输视频
  var playAudio = true //传输音频
  rtcPlayerObj
    .play(rtcSdpUrl, rtcHostIp, sig.myToken, cliToken, playVideo, playAudio)
    .then(function(session) {
      console.log('拉流成功:' + session)
    })
    .catch(function(reason) {
      console.log('拉流失败:' + reason)
      rtcPlayerObj.close()
      console.error(reason)
    })
}
var queryPlayConnCount = 0
function queryPlayConnectionState(cliToken) {
  if (!clientPlayers[cliToken]) {
    return
  }
  let ui = clientPlayers[cliToken].ui
  let rtcPlayerObj = clientPlayers[cliToken].player
  //查询到连接当前状态
  var peerState = rtcPlayerObj.getPlayConnectionState()
  queryPlayConnCount++
  console.log('queryPlayConnectionState()... cliToken=' + cliToken + '...peerState=' + peerState)
  if (peerState === 'failed' || peerState === 'closed') {
    console.log('拉流已断开！！！')
  } else if (peerState === 'disconnected') {
    if (queryPublishConnCount > 5) {
      console.log('拉流已断开！！！')
      return
    }
    console.log('拉流不稳定！！！')
    //3秒后再递归调用
    setTimeout(function() {
      queryPlayConnectionState(cliToken)
    }, 3000)
  } else {
    // ui.children('#playState').text('')
  }
}

/**
 * 检查是否是否有麦克风，若没有，则直接返回
 */
async function checkMic() {
  try {
    await navigator.mediaDevices.getUserMedia({ audio: true })
    hasMic = true
  } catch (error) {
    if (error.message === 'Requested device not found') {
      console.error('您的计算机未找到麦克风设备')
    } else {
      console.error('checkMic error', error)
    }
    hasMic = false
  }
}

// 生成随机数字符串
function randomNumstr(length) {
  if (typeof length !== 'number') {
    length = 4
  }
  var numStr = ''
  for (var i = 0; i < length; i++) {
    numStr += Math.floor(Math.random() * 10)
  }
  return numStr
}

/**
 * 业务代码
 */
if (
  getSession('access_token') &&
  store.getters.rtcType === 'srs' &&
  !window.location.href.includes('Intercom') &&
  !window.location.href.includes('realvideo') &&
  !window.location.href.includes('/externalHistory')
) {
  walkieRegist()
}

async function noticeHelmetMeet(helmetList) {
  // action为0是加入安全帽
  var sendMsg = {
    content: {
      cmd: 'GROUP_CHAT',
      code: '000',
      params: {
        // 发起对讲时时用helmetlist
        helmetList: helmetList,
        roomId: meetCode,
        fromUser: getSession('username'),
      },
    },
    header: {
      from: getSession('userId'),
      to: 'SYS',
      requireResponse: false,
    },
  }
  CHAT.chat(websocketapp.WALKIE, '', sendMsg)
}

/**
 * 退出登录时 关闭信令
 */
async function closeVideoWalkie() {
  if (publisher) {
    publisher.close()
  }
  if (sig) {
    // 请求离开会议
    sig.sigReqDisconnect()
    sig.sigClose()
  }
}

/**
 * 退出全部房间
 * @param {*} currenData 当前房间用户数据
 * @param {*} isEnterRoom 是否接通
 */
function exitRemoteRoomSRS(currenData, isEnterRoom) {
  console.log('退出全部房间', currenData, isEnterRoom)
  store.commit('openWaike', false)
  // 处理除去本身列表
  let helmetList = []
  let userList = currenData.userList
  let userId = getSession('userId')
  for (var i = 0; i < userList.length; i++) {
    if (userId !== userList[i].userId) {
      helmetList.push(userList[i].helmetId)
    }
  }
  // (1是拨通后挂断，2是未拨通挂断)
  let hangUp = ''
  if (isEnterRoom) {
    hangUp = '1'
  } else {
    hangUp = '2'
  }
  var sendMsg = {
    content: {
      cmd: 'GROUP_CHAT',
      code: '000',
      params: {
        // 挂断对讲时用to
        to: helmetList,
        hangUp: hangUp,
      },
    },
    header: {
      from: getSession('userId'),
      to: 'SYS',
      requireResponse: false,
    },
  }

  CHAT.chat(websocketapp.WALKIE, '', sendMsg)
}

export { VOLUME_OFF, VOLUME_ON }

export { setHandleHelmetLeave, helmetJoinMeetSRS, closeResetMeetSRS, walkieRegist, exitRemoteRoomSRS, closeVideoWalkie }
